import { SHOW_POPUP } from "core-web/state/models/Popups/constants";
import store from "core-web/state/store";

export const showPopup =
    (popup, data = {}, wrapper = null) =>
    (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popup,
            data,
            wrapper,
        });
    };

export default (popup, data, wrapper) => store.dispatch(showPopup(popup, data, wrapper));
